<template>
    <aside class="main-sidebar" style="float: left;height: calc(100% - 71px);min-height: 0px;z-index: 1">
    <section class="sidebar" id="section_sidebar" style="overflow-x: hidden;overflow-y: auto;height: 100%">
        <div class="user-panel">
            <div class="pull-left image">
                <img data-href="/js/a/sys/user/info" data-title="lesson_info_str" class="img-circle pointer"
                     src="../assets/plugins/images/user1.jpg">
            </div>
            <div class="pull-left info">
                <p>{{roleName}}</p>
                <a href="javascript:"><i class="fa fa-circle text-success"></i> 在线</a>
                <a href="javascript:log_out()"><i class="fa fa-sign-out text-danger"></i> 注销</a>
            </div>
        </div>
        <div id="leftMenu" data-widget="tree">
            <ul class="sidebar-menu">
                <template v-for="pmenu in currentMenus">
                    <li class="treeview" v-if="pmenu.type=='menu'" :key="pmenu.code" :class="pmenu.code">
                        <a href="javascript:" data-href="blank"  :title="pmenu.name" @click="toggleMenu(pmenu)">
                            <i class="fa fa-fw " :class="pmenu.icon || 'icon-folder'"></i>
                            <span>{{pmenu.name}}</span>
                            <span v-if="pmenu.children && pmenu.children.length > 0" class="pull-right-container"><i class="fa fa-angle-left pull-right"></i></span>
                        </a>
                        <ul class="treeview-menu" v-if="pmenu.children && pmenu.children.length > 0">
                            <template v-for="cmenu in pmenu.children">
                                <li class="treeview" :key="cmenu.code" :class="cmenu.code" :parent_code="pmenu.code" @click="toggleMenu(cmenu)">
                                    <a href="javascript:" class="menu_node" :title="cmenu.name">
                                        <span style="margin-left:20px;">{{cmenu.name}}</span>
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </li>
                </template>
            </ul>
        </div>
    </section>
</aside>
</template>
<script>
import $ from 'jquery';
export default {
    name:"LeftSide",
    components: {
        
    },
    data:function(){
        return {
            
        }
    },
    computed:{
        roleName:function(){
            return this.$store.state.user.jsmc || "";
        },
        activeMenu:function(){
            return this.$store.state.activeMenu || "";
        },
        currentMenus:function(){
            return this.$store.state.currentMenus || [];
        }
    },
    created:function(){
		
    },
    methods:{
       toggleMenu:function(menuNode){
           let clsName = "."+menuNode.code;
           if(menuNode.children && menuNode.children.length>0){
                if($(clsName).hasClass('menu_open')){
                    $(clsName).find('.treeview-menu').hide();
                    $(clsName).removeClass('menu_open');
                    $(clsName).find('.fa-angle-left').css('transform','');
                }
                else{
                    $(".treeview-menu").hide();
                    $("#leftMenu").find('.treeview').removeClass('menu_open');
                    $(clsName).addClass('menu_open');
                    $(clsName).find('.treeview-menu').show();
                    $(clsName).find('.fa-angle-left').css('transform','rotate(-90deg)');
                }
            }
            else{
                $("#leftMenu").find(".treeview").removeClass('treeview-item');
                $("#leftMenu").find(".treeview").removeClass('active');
                $(clsName).addClass("menu-open treeview-item active");
                this.$store.commit('setActiveMenu',menuNode);
                this.$router.push({name:menuNode.path});
            }

       }
    },
	mounted:function(){
		//初始化之前选中的菜单
		if(this.activeMenu && this.activeMenu.code){
			let parentCode = $("#leftMenu").find('.'+this.activeMenu.code).attr('parent_code');
			if(parentCode){
				//展开父菜单
				let parentClsName = "."+parentCode;
				if(!$(parentClsName).hasClass('menu_open')){
					$(".treeview-menu").hide();
					$("#leftMenu").find('.treeview').removeClass('menu_open');
					$(parentClsName).addClass('menu_open');
					$(parentClsName).find('.treeview-menu').show();
					$(parentClsName).find('.fa-angle-left').css('transform','rotate(-90deg)');
				}
				//选中当前节点
				let clsName = '.' + this.activeMenu.code;
				$("#leftMenu").find(".treeview").removeClass('treeview-item');
				$("#leftMenu").find(".treeview").removeClass('active');
				$(clsName).addClass("menu-open treeview-item active");
			}
			else{
				//选中当前节点
				let clsName = '.' + this.activeMenu.code;
				$("#leftMenu").find(".treeview").removeClass('treeview-item');
				$("#leftMenu").find(".treeview").removeClass('active');
				$(clsName).addClass("menu-open treeview-item active");
			}
		}
	
		
	}
}
</script>